import React, { useState, useEffect, useRef } from "react";
import { useSelector } from 'react-redux';
import ReportViewerRenderer from "./ReportViewerRenderer";

const ReportViewer = ({ study, activeTab }) => {

    const mounted = useRef(false);
    const [file, setFile] = useState(null);

    // Function will execute on click of button
    function base64ToArrayBuffer(base64) {
        var binaryString = window.atob(base64);
        var binaryLen = binaryString.length;
        var bytes = new Uint8Array(binaryLen);
        for (var i = 0; i < binaryLen; i++) {
            var ascii = binaryString.charCodeAt(i);
            bytes[i] = ascii;
        }
        return [...bytes];
    }

    useEffect(() => {
        mounted.current = true;
    }, []);

    useEffect(() => {
        if (mounted.current && !file && activeTab === "3") {
            setFile(base64ToArrayBuffer(study.reportFile));
        }
    }, [mounted.current, activeTab]);

    if (!study || !Object.keys(study).length) {
        return <></>;
    }

    return (

        <>
            {/* react-pdf performs === comparisons so React.memo is required ONLY for the props it needs.
                Otherwise, it will refresh all the props and the render will fail           
            */}
            {file && 
                <ReportViewerRenderer file={file} />
            }
        </>
    )
}

export default React.memo(ReportViewer);